import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import TrafficLight from "./TrafficLight";

/**
 * Care News article card. Mirrors WimArticleCard structurally (same proportions,
 * spacing, hover state) so the Care News index reads as a sibling of the WIM Blog
 * rather than a different system. Teal accent throughout.
 *
 * Compact by design (Aug 2026) — see WimArticleCard.jsx for the rationale:
 * a restrained 16:9 thumbnail, omitted entirely when there's no image.
 */
function formatDate(iso) {
  try { return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }); }
  catch { return iso; }
}

export default function CareNewsCard({ item, testIdPrefix = "care-news-card" }) {
  return (
    <Link
      to={`/care-news/${item.slug}`}
      className="card-base overflow-hidden flex flex-col group"
      data-testid={`${testIdPrefix}-${item.slug}`}
    >
      {item.featured_image && (
        <div className="aspect-[16/9] overflow-hidden">
          <img src={item.featured_image} alt="" className="w-full h-full object-cover" />
        </div>
      )}
      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-center justify-between gap-3 mb-3">
          <span className="pill bg-teal-50 text-teal">{item.category}</span>
          {item.published_at ? (
            <span className="text-xs text-ink-soft flex items-center gap-1">
              <Calendar className="w-3.5 h-3.5" /> {formatDate(item.published_at)}
            </span>
          ) : null}
        </div>
        {item.traffic_light ? <TrafficLight level={item.traffic_light} className="mb-3" /> : null}
        <h3 className="font-display text-xl font-semibold leading-snug group-hover:text-teal transition-colors">
          {item.title}
        </h3>
        <p className="mt-2 text-ink-muted text-sm flex-1">{item.summary}</p>
        <div className="mt-4 flex items-center gap-1 text-teal font-medium text-sm">
          Read More <ArrowRight className="w-4 h-4" />
        </div>
      </div>
    </Link>
  );
}
